import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { ActivatedRoute, Router } from "@angular/router";

import { InventarioIAService } from "../inventario-ia.service";
import { InventarioIAHistorial } from "src/app/shared/model/iso42001/inventario-ia.model";

@Component({
  selector: "app-historial-inventario-ia",
  standalone: true,
  templateUrl: "./historial-inventario-ia.component.html",
  styleUrls: ["./historial-inventario-ia.component.css"],
  imports: [CommonModule, DatePipe, MatButtonModule],
})
export class HistorialInventarioIAComponent implements OnInit {
  historial: InventarioIAHistorial[] = [];
  idInventarioIa = 0;
  loading = false;

  /**
   * La bitácora guarda el nombre físico de la columna (InventarioIABuss.diffYRegistrar).
   * Sin esta traducción el usuario ve "nombre_ia" o "id_ciclo_vida" en pantalla.
   * Las llaves deben coincidir EXACTAMENTE con las que registra el backend.
   */
  private static readonly ETIQUETAS: { [campo: string]: string } = {
    nombre_ia: "Nombre del sistema de IA",
    version: "Versión",
    proposito: "Propósito",
    uso_previsto: "Uso previsto",
    id_area: "Área propietaria",
    propietario_externo: "Propietario externo",
    id_ciclo_vida: "Etapa del ciclo de vida",
    fecha_alta: "Fecha de alta",
    fecha_baja: "Fecha de baja",
    ubicacion: "Ubicación",
    componentes_sistema: "Componentes del sistema",
    componentes_datos: "Componentes de datos",
    herramientas_ia: "Herramientas de IA",
    sistemas_informaticos: "Sistemas informáticos",
    recursos_humanos: "Recursos humanos",
    procesos_intervencion: "Procesos en los que interviene",
    id_nivel_supervision: "Nivel de supervisión humana",
    impactos: "Impactos",
    estatus: "Estatus",
  };

  constructor(
    private service: InventarioIAService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (!id) {
      this.regresar();
      return;
    }
    this.idInventarioIa = Number(id);
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.service.historial(this.idInventarioIa).subscribe((res) => {
      this.historial = (res && res.historial) || [];
      this.loading = false;
      this.cdr.detectChanges();
    });
  }

  regresar(): void {
    this.router.navigate(["/admin/inventario-ia/gestion"]);
  }

  /**
   * Si apareciera un campo sin traducir, se muestra legible (guiones bajos por
   * espacios) en vez de crudo: preferible a dejarlo en blanco.
   */
  etiquetaCampo(campo: string): string {
    if (!campo) {
      return "—";
    }
    const etiqueta = HistorialInventarioIAComponent.ETIQUETAS[campo];
    return etiqueta || campo.replaceAll("_", " ");
  }

  badgeClass(accion: string): string {
    switch (accion) {
      case "ALTA":
        return "is-active";
      case "BAJA":
        return "is-danger";
      case "REACTIVACION":
        return "is-pending";
      default:
        return "is-inactive";
    }
  }
}
